import { render, staticRenderFns } from "./hlw.vue?vue&type=template&id=724b98dc&scoped=true&"
var script = {}
import style0 from "./hlw.vue?vue&type=style&index=0&id=724b98dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724b98dc",
  null
  
)

export default component.exports